export default __webpack_public_path__ + "static/media/cargo-2.7db0906d.svg";